import { render, staticRenderFns } from "./UserAccessControl.vue?vue&type=template&id=58aec92a"
import script from "./UserAccessControl.vue?vue&type=script&lang=js"
export * from "./UserAccessControl.vue?vue&type=script&lang=js"
import style0 from "./UserAccessControl.vue?vue&type=style&index=0&id=58aec92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports